import { Box, Flex, styled } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled(Flex, {
    padding: '$4',
  }),

  Image: styled('div', {
    width: '50px',
    textAlign: 'center',
    img: {
      width: '36px',
    },
  }),
  Box: styled(Box, {
    width: '100%',
    padding: '$0 $4',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  }),
};
